export default __webpack_public_path__ + "static/media/dreamstore.3468ac60.png";